import {Routes} from '@src/Constant/routes';
import {pathToRegexp} from 'path-to-regexp';

const modalRoutes: Routes[] = [
  Routes.PAYWALL,
  Routes.TERMS_AND_CONDITION,
  Routes.BOOKMARKS,
  Routes.NEWS_SINGLE,
  Routes.PROFILE_ACHIEVEMENT,
  Routes.PROFILE_NOTIFICATION,
  Routes.PROFILE_OPPORTUNITIES,
  Routes.VOD_SINGLE,
  Routes.VOD_COLLECTION,
  Routes.PODCAST_SINGLE,
  Routes.LINKED_JOB,
  Routes.COURSE_UNIT,
  Routes.PARTNER_SINGLE,
  Routes.QUIZ_QUESTION,
  Routes.PERSONALITY,
  Routes.SINGLE_JOB,
  Routes.ENTREPRENEURIAL_HUB,
  Routes.JOB_VACANCIES,
  Routes.JOB_HUB,
  Routes.OPPORTUNITY_SINGLE,
  Routes.EXAM,
  Routes.EXAM_RESULT_OVERVIEW,
  Routes.FORMS,
  Routes.QUIZZ_SURVEY_COLLECTION,
  Routes.QUIZZ_SURVEY,
  Routes.PLAYER_QUIZ_SURVEY,
  Routes.THANK_YOU,
  Routes.TUTORIAL,
  Routes.CHOOSE_PLAN,
  Routes.SUCCESS_PLAN,
];

const modalRoutesNotMobile: Routes[] = [
  Routes.TERMS_AND_CONDITION,
  Routes.BOOKMARKS,
  Routes.PAYWALL,
  Routes.PROFILE_ACHIEVEMENT,
  Routes.PROFILE_NOTIFICATION,
  // Routes.VOD_SINGLE,
  // Routes.VOD_COLLECTION,
  Routes.PODCAST_SINGLE,
  Routes.LINKED_JOB,
  // Routes.COURSE_UNIT,
  Routes.PARTNER_SINGLE,
  Routes.PERSONALITY,
  Routes.SINGLE_JOB,
  Routes.ENTREPRENEURIAL_HUB,
  Routes.OPPORTUNITY_SINGLE,
  Routes.FORMS,
  Routes.QUIZZ_SURVEY_COLLECTION,
  Routes.QUIZZ_SURVEY,
  Routes.PLAYER_QUIZ_SURVEY,
  Routes.JOB_VACANCIES,
  Routes.JOB_HUB,
  Routes.CHOOSE_PLAN,
  Routes.SUCCESS_PLAN,
];

export const isModalRoute = (path: string, isMobile: boolean): boolean => {
  let res = true;
  if (!modalRoutes.length) {
    res = false;
  }

  const modalRouteNotMobileRegex = pathToRegexp(modalRoutesNotMobile, []);

  if (isMobile && modalRouteNotMobileRegex.test(path)) {
    res = false;
  } else {
    const modalRouteRegex = pathToRegexp(modalRoutes, []);
    res = modalRouteRegex.test(path);
  }

  return res;
};
